import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuth } from '../contexts/AuthContext';
import WelcomeScreen from '../screens/WelcomeScreen';
import LoginScreen from '../screens/LoginScreen';
import InviteAcceptScreen from '../screens/InviteAcceptScreen';
import EmployeeNavigator from './EmployeeNavigator';
import AdminNavigator from './AdminNavigator';
import { colors, fonts } from '../config/theme';

const Stack = createNativeStackNavigator();

// Deep links: /invite?t=<token> (web URL, or staffmanager://invite?t= on native)
// routes straight to the onboarding screen.
const linking = {
  prefixes: ['staffmanager://'],
  config: {
    screens: {
      Welcome: '',
      Login: 'login',
      InviteAccept: 'invite',
    },
  },
};

const navTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: colors.background,
    card: colors.background,
    text: colors.textPrimary,
    border: 'transparent',
    primary: colors.primary,
  },
};

const headerOptions = {
  headerStyle: { backgroundColor: colors.background },
  headerTintColor: colors.textPrimary,
  headerShadowVisible: false,
  headerTitleStyle: { fontFamily: fonts.display, fontWeight: '700' },
  contentStyle: { backgroundColor: colors.background },
  animation: 'slide_from_right',
};

export default function AppNavigator() {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <View style={styles.loading}><ActivityIndicator size="large" color={colors.primary} /></View>;
  return (
    <NavigationContainer linking={linking} theme={navTheme}>
      {!user ? (
        <Stack.Navigator screenOptions={headerOptions}>
          <Stack.Screen name="Welcome" component={WelcomeScreen} options={{ headerShown: false }} />
          <Stack.Screen name="Login" component={LoginScreen} options={{ title: 'Вход' }} />
          <Stack.Screen name="InviteAccept" component={InviteAcceptScreen} options={{ title: 'Приглашение' }} />
        </Stack.Navigator>
      ) : isAdmin ? (
        <AdminNavigator />
      ) : (
        <EmployeeNavigator />
      )}
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  loading: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: colors.background },
});
